

























import Vue from 'vue'
import DefaultTemplate from '@/components/product/templates/DefaultTemplate.vue'
import ClassicTemplate from '@/components/product/templates/ClassicTemplate.vue'
import NewYorkTemplate from '@/components/product/templates/NewYorkTemplate.vue'
import {
  UserPostCompletionService,
  PostService,
  getUserId,
  UserProductTrackingService,
  UserPurchaseService
} from '../services'
import Category from '../models/Category'
import {
  getHeroAlignmentClass,
  getHeroSpacingClass,
  createCategoryPostTree,
  computeNextPost
} from '../helper'
import CategoryTreeNode from '../models/CategoryTreeNode'
import { defaultProductBackground } from '../helper/constants'
import UISpinner from '@/components/common/UISpinner.vue'

export default Vue.extend({
  props: {
    product: {
      type: Object
    },
    instructor: {
      type: Object
    },
    fetching: Boolean,
    productStarted: Boolean,
    logo: String,
    selectedTheme: {
      type: String,
      default: 'Default'
    }
  },
  components: {
    UISpinner,
    DefaultTemplate,
    ClassicTemplate,
    NewYorkTemplate
  },
  computed: {
    productId(): string {
      return this.$route.params.id
    },
    disableActions(): object {
      const inPreviewMode = !!this.$route.query.builder
      return {
        pointerEvents: inPreviewMode ? 'none' : 'all'
      }
    },
    templateId(): string {
      return this.$route.query.template_id || 'default'
    },
    categoryTree(): CategoryTreeNode[] {
      return createCategoryPostTree(null, this.categories)
    },
    courseCompleted(): boolean {
      return this.completedPosts === this.totalPosts
      // if (this.completedPosts > 0 && !this.nextPost.id) {
      //   return true
      // } else {
      //   return false
      // }
    },
    heroSection(): object {
      let templateId = this.templateId
      if (this.product && this.product.customizations) {
        const customization = this.product.customizations
        if (!this.templateId) {
          templateId = customization?.templateId || 'default'
        }

        return {
          alignment: getHeroAlignmentClass(customization.heroTextAlignment),
          spacing: getHeroSpacingClass(customization.heroSpacing),
          background:
            customization.heroImage || defaultProductBackground[templateId],
          overlayColor: customization.heroOverlayColor || 'rgba(0, 0, 0, 0)'
        }
      }

      return {
        alignment: 'text-center' as string,
        spacing: 'py-16' as string,
        background: defaultProductBackground[templateId],
        overlayColor: 'rgba(0, 0, 0, 0)'
      }
    }
  },
  async mounted() {
    await this.fetchCategories()
    await this.fetchCompletionData()
    // this.computeNextPost()
    this.nextPost = computeNextPost(this.categoryTree, this.postIdsCompleted)
  },
  data() {
    return {
      fetchingProduct: false,
      fetchingCategories: false,
      categories: [] as Category[],
      totalPosts: 0,
      completedPosts: 0,
      postIdsCompleted: new Set() as Set<string>,
      nextPost: {} as CategoryTreeNode
    }
  },
  methods: {
    async fetchCategories() {
      this.fetchingCategories = true

      try {
        // this.categories = await CategoryService.findAll({
        //   product_id: this.productId,
        //   visibility: CategoryVisibility.published,
        //   posts: true,
        //   published_posts: true
        // })
        this.categories = await UserPurchaseService.getCategories({
          product_id: this.productId
        })
        // console.log('categories fetched --> ', this.categories)
      } catch (error) {
        console.error('Error while fetching product --> ', error)
      } finally {
        this.fetchingCategories = false
      }
    },
    fetchCompletionData() {
      const fetchingCompletedPosts = this.fetchCompletedPosts()
      const fetchingPublishedPosts = this.fetchNoOfPublishedPosts()
      return Promise.all([fetchingCompletedPosts, fetchingPublishedPosts])
    },
    async fetchCompletedPosts() {
      const userId = getUserId()

      const completedResp = await UserPostCompletionService.findAll({
        product_id: this.productId,
        user_id: userId
      })

      this.completedPosts = completedResp.length

      this.postIdsCompleted = completedResp.reduce(
        (agg: Set<string>, completed: any) => {
          const { postId } = completed
          agg.add(postId)
          return agg
        },
        new Set()
      )
    },
    async fetchNoOfPublishedPosts() {
      const publishedResp = await PostService.noOfPublishedPosts({
        product_id: this.productId
      })

      this.totalPosts = publishedResp.count
    },
    // computeNextPost() {
    //   let nextPostToGo = null

    //   const tree = this.removeUnavailableCategories(
    //     [...this.categoryTree],
    //     this.postIdsCompleted
    //   )

    //   if (this.completedPosts > 0) {
    //     const lastCompletedPost = findLastCompletedPost(
    //       tree,
    //       this.postIdsCompleted
    //     )

    //     // find the next post after the last post that is completed
    //     if (lastCompletedPost) {
    //       console.log('available tree --> ', tree)
    //       nextPostToGo = findNextPostToComplete(
    //         tree,
    //         lastCompletedPost.id,
    //         this.postIdsCompleted
    //       )
    //     }
    //   }

    //   if (!nextPostToGo) {
    //     // if there are no completed posts, or the last post in course is completed
    //     const firstUncompletedPost = findFirstUncompletedPost(
    //       tree,
    //       this.postIdsCompleted
    //     )
    //     if (firstUncompletedPost) {
    //       nextPostToGo = firstUncompletedPost
    //     }
    //     // else, couldn't find an uncompleted post
    //   }

    //   if (nextPostToGo) {
    //     this.nextPost = nextPostToGo
    //   } else {
    //     // all posts done, course is completed
    //   }
    // },
    // removeUnavailableCategories(categoryTree: Array<CategoryTreeNode>) {
    //   const availableNodes = categoryTree.filter((node: CategoryTreeNode) => {
    //     if (node.type === CategoryTreeNodeType.Category) {
    //       const cat = node.node as Category
    //       return cat.available
    //     }

    //     return true
    //   })

    //   return availableNodes.map((node: CategoryTreeNode) => {
    //     if (node.type === CategoryTreeNodeType.Category && node.childs) {
    //       node.childs = this.removeUnavailableCategories(node.childs)
    //     }
    //     return node
    //   })
    // },
    goToNextPost() {
      if (!this.productStarted) {
        // start the product
        UserProductTrackingService.trackProductStart(this.productId)
      }
      console.log('go to next post --> ', this.nextPost.id)
      if (this.nextPost.id) {
        this.$router.push({
          name: 'post-overview',
          params: {
            id: this.productId,
            category_id: this.nextPost.parent,
            post_id: this.nextPost.id
          }
        })
      }
    }
  },
  watch: {
    async productId() {
      await this.fetchCategories()
      await this.fetchCompletionData()
      // this.computeNextPost()
      this.nextPost = computeNextPost(this.categoryTree, this.postIdsCompleted)
    }
  }
})
